enum ContributionType {
  GENERAL = 'general',
  GRANT = 'grant',
  IN_KIND = 'in_kind',
  PLANNED_GIVING = 'planned_giving',
  PLEDGE = 'pledge',
  RECURRING = 'recurring',
  RESTRICTED = 'restricted',
  SPONSORSHIP = 'sponsorship',
  TICKET = 'ticket',
  TIME = 'time',
}

export default ContributionType;
